<div class="cb-layout-group">
    <ng-content></ng-content>
</div>